import {Component, computed, inject, input, OnInit, signal} from '@angular/core'
import {AbstractControl} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {NavigationEnd, Router} from '@angular/router'
import {filter, map} from 'rxjs/operators'
import {HOME_ROUTE_PATH} from '../../../application/data-types'
import {CustomerService} from '../../../services/customer.service'
import {DatastoreService} from '../../../services/datastore.service'
import {toSignal} from '@angular/core/rxjs-interop'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-duplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['./duplicate.component.scss'],
  imports: [MatButton]
})
export class DuplicateComponent implements OnInit {
  public customerService = inject(CustomerService)

  public router = inject(Router)

  public group = input.required<AbstractControl>()

  public applicantNumber = input<number>(0)

  public readonly value = signal('')

  public readonly url = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.router.url)
    ),
    {initialValue: this.router.url}
  )

  public readonly showSaved = computed(() =>
    this.customerService.existingCustomers().has(this.value()) && this.url() === '/main')

  private readonly dataStoreService = inject(DatastoreService)

  private loaded = ''

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  get personNummer(): string {
    return this.group().value
  }

  public ngOnInit(): void {
    this.value.set(this.personNummer)
    this.group().valueChanges
      .pipe(this.takeUntilDestroyed())
      .subscribe((v: string) => this.value.set(v))


    this.group().statusChanges
      .pipe(
        // Very important to check against the VALUE not the group status as that may change
        // when someone updates the group.
        filter((v: string) => v === 'VALID')
      )
      .subscribe(() => {
        if (this.loaded !== this.personNummer && !this.customerService.existingCustomers().has(this.personNummer)) {
          this.loaded = this.personNummer
          this.dataStoreService.loadKalp(this.personNummer, this.applicantNumber())
        }
      })
  }

  /**
   * Load an existing customer when it already exists.
   *
   * Only call this when you have verified that the customer DO exist
   */
  public loadCustomer(): void {
    const id = this.customerService.existingCustomers().get(this.personNummer)
    this.router.navigate([HOME_ROUTE_PATH, id]).then()
  }
}
